import { IProfile } from '../../models/profile';
import { IResult, IErrorResult } from '../../models/result-models';
import {
    LOAD_PROFILE_SUCCESS,
    SAVE_PROFILE_SUCCESS,
    LOAD_PROFILE_ERROR,
    SAVE_PROFILE_ERROR,
    ACTION_PROFILE_FATAL,
} from './profile-actions';

interface ILoadProfileSuccessAction {
    type: 'LOAD_PROFILE_SUCCESS';
    result: IResult<IProfile>;
}

interface ISaveProfileSaveAction {
    type: 'SAVE_PROFILE_SUCCESS';
    result: IResult<IProfile>;
}

interface ILoadProfileErrorAction {
    type: 'LOAD_PROFILE_ERROR';
    result: any;
}

interface ISavedProfileErrorAction {
    type: 'SAVE_PROFILE_ERROR';
    result: any;
}

interface IActionProfileFatal {
    type: 'ACTION_PROFILE_FATAL';
    payload: IErrorResult;
}

const initialState = {
    ok: false,
};

type KnownAction =
    | ILoadProfileSuccessAction
    | ILoadProfileErrorAction
    | ISaveProfileSaveAction
    | ISavedProfileErrorAction
    | IActionProfileFatal;

export const profileReducer = (
    state: IResult<IProfile> = initialState,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_PROFILE_SUCCESS:
            return action.result;
        case LOAD_PROFILE_ERROR:
            return {
                ok: false,
                message: action.result.message,
            } as IResult<IProfile>;
        case SAVE_PROFILE_SUCCESS:
            return action.result;
        case SAVE_PROFILE_ERROR:
            return {
                ok: false,
                data: state ? state.data : null,
                errors: action.result.errors,
                message: action.result.message,
            } as IResult<IProfile>;
        case ACTION_PROFILE_FATAL:
            return {
                ok: false,
                data: state.data,
                message: action.payload.errorMessage,
            };
        default:
            return state;
    }
};
